import React, { Component, Fragment, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import {
  ArchiosExpressionProfile,
  ExpressionBuilderView,
  ExpressionContextMenuComponent,
  ExpressionTokenComponent,
  GroupToken,
  StandardExpressionBuilderView,
  Syntax,
  TokenVariable,
} from '@trlogic/ui-pack';
import DataType from '../../../../constant/DataType';
import { generateUUIDV4 } from 'util/Generator';
import { ExpressionUtil } from '../../../../util/ExpressionUtil';

class ChartArchiosExpressionComponent extends Component<Props, State> {
  public state: State = new State();

  public render(): ReactNode {
    const { expression, expressionView } = this.state;
    const { id } = this.props;

    return (
      <div className='bg-[#FAFAFA] border-[f-black-5] border-[0.5px] rounded-[2px] w-full' id={`expression_builder_${id}`}>
        {expression && expressionView && (
          <Fragment>
            {createPortal(<ExpressionContextMenuComponent context={expressionView.getContext()} close={this.onCloseContextMenu} />, document.body)}
            <ExpressionTokenComponent syntax={expressionView.getModel()} view={expressionView} />
          </Fragment>
        )}
      </div>
    );
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.variables !== this.props.variables) {
      this.build();
    }
  }

  public async componentDidMount() {
    this.build();
  }

  public build() {
    let expression = this.state.expression;
    let variables = this.state.variables;
    if (this.props.syntax) expression = this.props.syntax;
    if (this.props.variables) variables = this.props.variables;
    const expressionView: ExpressionBuilderView = new StandardExpressionBuilderView({
      el: `#expression_builder_${this.props.id}`,
      model: expression,
      profile: new ArchiosExpressionProfile(),
      returnType: { dataType: DataType.BOOLEAN },
      onCtrlToken: ExpressionUtil.onNavigateToken,
    });
    expressionView.getContext().setVariables(variables);
    expressionView.onChange(this.onChangeSyntax as VoidFunction);
    this.setState({ expressionView, expression }, () => expressionView.initialize());
  }

  public componentWillUnmount() {
    const { expressionView } = this.state;
    expressionView?.terminate();
  }

  private onChangeSyntax = (updatedExpression: Syntax): void => {
    const { onChangeSyntax } = this.props;
    this.setState({ expression: updatedExpression });
    onChangeSyntax(updatedExpression);
  };

  private onCloseContextMenu() {}
}

interface Props {
  syntax: Syntax;
  variables: Record<string, TokenVariable[]>;
  onChangeSyntax: (syntax: Syntax) => void;
  id: string;
}

class State {
  expressionView: ExpressionBuilderView | undefined;
  variables: Record<string, TokenVariable[]> = {};
  expression: Syntax = {
    id: generateUUIDV4(),
    value: {
      type: 'TokenGroup',
      properties: { dataType: DataType.BOOLEAN },
    } as GroupToken,
    children: [],
  };
}

export default ChartArchiosExpressionComponent;
